<script>
import Vue from "vue";
import request from "@/axios/index";
import { getMenuList } from "@/api/menu";
import { getPermisson } from "@/api/role";
import { getHeader } from "@/api/login.js";
import { toDoListStatistics } from "@/api/message.js";
const state = {
  //the user object
  sessionData: null,
  userObj: {
    oid: null,
    name: "小红红",
    token: "",
  },
  userHeader: {},
  userObjSecurity: {}, //安全中心所需用户信息
  tenantData: {},
  menuData: [],
  activeTabBar: "", //menuCode==>当前tab
  openedTabBar: [], //已打开的tab
  loadMainStatus: false, //axios时全屏的loading
  isReload: false, //是否刷新路由
  PATHMAP: {}, //存放菜单路径map，
  messageCount: {
    total: 0,
    noticeList: 0,
    queryGoldPage: 0,
    reviewGold: 0,
    reviewGoldModified: 0,
    reviewGoldPay: 0,
    reviewFinance: 0,
    toReviewVoucher: 0,
    reviewGoldGuarantee: 0
  },
  cachedViews: [], //需要缓存的组件name
};

const mutations = {
  setSessionData: function (state, data) {
    state.sessionData = data;
  },
  setUserObj: function (state, data) {
    state.userObj = data;
  },
  setUserObjSecurity: function (state, data) {
    state.userObjSecurity = data;
  },
  setTenant: function (state, data) {
    state.tenantData = data;
  },
  setUserHeader: function (state, data) {
    state.userHeader = data;
  },
  setLoadMainStatus: function (state, data) {
    state.loadMainStatus = data;
  },
  setMenuData: function (state, data) {
    state.menuData = [];
    const now = new Date().getTime();
    const firstMenu = [
      {
        isCheck: "",
        menuCode: "gongzuotai",
        menuName: "工作台",
        modified: "",
        path: "main",
        updateTime: null,
      },
    ];
    data = firstMenu.concat(data || []);
    for (let i = 0; i < data.length; i++) {
      //将没有menuCode的菜单初始化赋值
      if (data[i].menuCode) {
        const code = data[i].menuCode;
        if (data[i].subnav) {
          for (let j = 0; j < data[i].subnav.length; j++) {
            data[i].subnav[j].menuCode =
              data[i].subnav[j].menuCode || code + "_" + data[i].subnav[j].path;
            const sub_code = data[i].subnav[j].menuCode;
            if (data[i].subnav[j].subnav) {
              for (let k = 0; k < data[i].subnav[j].subnav.length; k++) {
                data[i].subnav[j].subnav[k].menuCode =
                  data[i].subnav[j].subnav[k].menuCode ||
                  sub_code + "_" + data[i].subnav[j].subnav[k].path;
              }
            }
          }
        }
      }
    }
    let last = [
      // {
      // 	icon:"anticon-schedule",
      // 	isCheck: "",
      // 	menuCode: "bank",
      // 	menuName: "银行相关",
      // 	modified: "",
      // 	path: "bank",
      // 	updateTime: null,
      // 	subnav:[
      // 		{
      // 			isCheck: "",
      // 			menuCode: "yinhangjiandang",
      // 			menuName: "银行建档",
      // 			modified: "",
      // 			path: "bank/bankList",
      // 			updateTime: null
      // 		}
      // 	]
      // },
      // {
      // 	icon:"anticon-schedule",
      // 	isCheck: "",
      // 	menuCode: "danju",
      // 	menuName: "单据管理",
      // 	modified: "",
      // 	path: "bill-manage",
      // 	updateTime: null,
      // 	subnav:[
      //     {
      // 			isCheck: "",
      // 			menuCode: "yingfudanju",
      // 			menuName: "应付单据",
      // 			modified: "",
      // 			path: "bill-issue/payable",
      // 			updateTime: null
      // 		},
      // 		{
      // 			isCheck: "",
      // 			menuCode: "yingshouzhangkuan",
      // 			menuName: "应收单据",
      // 			modified: "",
      // 			path: "bill-manage/receivable",
      // 			updateTime: null
      // 		}
      // 	]
      // }
    ];
    state.menuData = data.concat(last);
  },
  setActiveTabBar: function (state, data) {
    state.activeTabBar = data;
  },
  setOpenedTabBar: function (state, data) {
    state.openedTabBar = data;
  },
  addOrGoTab: function (state, menuObj) {
    //打开、切换至tab
    let openedTabBarNames = state.openedTabBar.map((item) => item.menuCode);
    let newTabName = menuObj.menuCode;
    if (openedTabBarNames.indexOf(newTabName) > -1) {
      //已存在tab
      state.activeTabBar = newTabName;
      return;
    }
    state.openedTabBar.push({ ...menuObj });
    state.activeTabBar = newTabName;
  },
  setIsReload: function (state, data) {
    state.isReload = data;
  },
  setPATHMAP: function (state, data) {
    state.PATHMAP = data;
  },
  setMessageCount: function (state, data) {
    state.messageCount = data;
  },
  setCachedViews: function (state, name) {
    if (state.cachedViews.includes(name)) return;
    if (name) {
      state.cachedViews.push(name);
    }
  },
};

const getters = {
  getSessionData: function (state) {
    return state.sessionData;
  },
  getUserObj: function (state) {
    return state.userObj;
  },
  getUserObjSecurity: function (state) {
    return state.userObjSecurity;
  },
  getTenant: function (state) {
    return state.tenantData;
  },
  getUserHeader: function (state, data) {
    return state.userHeader;
  },
  getLoadMainStatus: function (state) {
    return state.loadMainStatus;
  },
  getMenuData: function (state) {
    return state.menuData;
  },
  getOpenedTabBar: function (state) {
    return state.openedTabBar;
  },
  getActiveTabBar: function (state) {
    return state.activeTabBar;
  },
  getIsReload: function (state) {
    return state.isReload;
  },
  getPATHMAP: function (state) {
    return state.PATHMAP;
  },
  getMessageCount: function (state) {
    return state.messageCount;
  },
  getCachedViews: function (state) {
    return state.cachedViews;
  },
};

const actions = {
  getPermissonAsync({ dispatch, commit, state }) {
    return new Promise((resolve, reject) => {
      getPermisson()
        .then((res) => {
          let roles = res.data.map((i) => i.roleCode);
          localStorage.setItem("AVAILABLEROLE", JSON.stringify(roles));
          let curRole = localStorage.getItem("CURRENTROLE");
          if (curRole && JSON.parse(curRole).length > 0) {
            roles = JSON.parse(curRole);
          } else {
            localStorage.setItem("CURRENTROLE", JSON.stringify(roles));
          }
          getMenuList({
            roleCodes: roles.join(","),
          })
            .then((res) => {
              let menuList = [];
              if (state.sessionData.createUser === "1") {
                console.log(state.userObj.status);
                if (state.userObj.status === "2") {
                  menuList = [
                    {
                      icon: "anticon-user",
                      menuCode: "MENU0500",
                      menuName: "用户中心",
                      subnav: [
                        {
                          isCheck: "",
                          menuCode: "",
                          menuName: "个人认证",
                          modified: "",
                          path: "security/personalAuthentication",
                          updateTime: null,
                        },
                        {
                          isCheck: "",
                          menuCode: "",
                          menuName: "安全中心",
                          modified: "",
                          path: "security/main",
                          updateTime: null,
                        },
                      ],
                    },
                  ];
                } else {
                  //个人注册 未认证通过
                  menuList = [
                    {
                      icon: "anticon-user",
                      menuCode: "MENU0500",
                      menuName: "用户中心",
                      subnav: [
                        {
                          isCheck: "",
                          menuCode: "",
                          menuName: "个人认证",
                          modified: "",
                          path: "security/personalAuthentication",
                          updateTime: null,
                        },
                      ],
                    },
                  ];
                }
              } else {
                if (state.userObj.aprvStCd != "1") {
                  //认证状态未认证、待处理、认证未通过、认证中
                  menuList = [
                    {
                      icon: "anticon-user",
                      menuCode: "MENU0500",
                      menuName: "用户中心",
                      subnav: [
                        {
                          isCheck: "",
                          menuCode: "",
                          menuName: "认证管理",
                          modified: "",
                          path: "security/vertify-management",
                          updateTime: null,
                        },
                      ],
                    },
                  ];
                } else {
                  menuList = res.data;
                }
              }

              commit("setMenuData", menuList);

              resolve();
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  setSessionAsync({ commit, state }) {
    return new Promise((resolve, reject) => {
      request
        .axios({
          url: "/session",
          type: "get",
        })
        .then((res) => {
          commit("setSessionData", res.data);
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  setUserObjAsync({ commit, state }) {
    return new Promise((resolve, reject) => {
      request
        .axios({
          url: "/user/center/getUserInfo",
        })
        .then((res) => {
          // 请求保理商信息，为祺信开立流程默认的保理商
          request
            .axios({
              url: "/selectTenant",
            })
            .then((tenant) => {
              commit("setTenant", tenant.data.grid.list[0] || {});
              commit("setUserObj", res.data);
              resolve(res.data);
            });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getHeaderAsync({ commit, state }) {
    getHeader()
      .then((res) => {
        commit("setUserHeader", res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  },
  // 查询消息相关数量
  getMessageCount({ commit, state }) {
    toDoListStatistics()
      .then((res) => {
        commit("setMessageCount", res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
</script>



// WEBPACK FOOTER //
// src/store/home_store.vue